
import { Component, Vue } from "vue-property-decorator";
@Component({
  components: {
    Header: () => import("@/components/Jobs/Common/Header.vue"),
    Hero: () => import("@/components/Jobs/Homepage/Hero.vue"),
    RecentOffers: () => import("@/components/Jobs/Homepage/RecentOffers.vue"),
    CreateProfile: () => import("@/components/Jobs/Homepage/CreateProfile.vue"),
    HowWeWork: () => import("@/components/Jobs/Homepage/HowWeWork.vue"),
    Footer: () => import("@/components/Jobs/Homepage/Footer.vue"),
  },
})
export default class HomepageJobs extends Vue {}
